import { Admin } from '@scribe-sas/types/admin'
import ApiService from 'services/ApiService'

export default class SubscriptionsTransportLayer {
  public async extendFreeTrial(
    subscriptionId: string,
    endsAt: string,
    haveMadeWithScribe: boolean,
  ) {
    const response = await ApiService.put<
      Admin.SubscriptionsUpdate.RequestBody,
      Admin.SubscriptionsUpdate.ResponseBody,
      void
    >(`/subscriptions/${subscriptionId}`, {
      subscription: {
        ends_at: endsAt,
        have_made_with_scribe: haveMadeWithScribe,
      },
    })
    return response
  }
}
